/*
 Zduplikováno z ajaxHandler.es6 - pouze pro refaktor es6 tříd
 Použij ApiClient a routu s kontrolou tokenu
 */
export default class PromiseHandler
{

   constructor() {
   }

   async post<T = any>(url :string, data = {}) : Promise<T> {
      // @ts-ignore
      const response = await fetch(url, {
         ...this.defaultHeaders(),
         ...{
            method: "POST",
            body: JSON.stringify(data),
         }
      });
      return response.json().then((response) => {
         if(response['unloggedUser'])
            location.href = response['unloggedUser'];

         const messages = response['messages'];
         delete response['messages'];

         if(messages === undefined || messages.length === 0)
            return response;

         messages.forEach(function(message :object) {
            // @ts-ignore
            toastr[message['type']](message['message'], message['title'], JSON.parse(message['settingJson']));
         });

         return response;
      });
   }

   defaultHeaders() {
      return {
         mode: "cors", // no-cors, *cors, same-origin
         cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
         credentials: "same-origin", // include, *same-origin, omit
         headers: {
            "Content-Type": "application/json",
            'X-Requested-With': 'XMLHttpRequest', // for backward compability with Environment::isAjax()
         },
         redirect: "follow", // manual, *follow, error
         referrerPolicy: "strict-origin", // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
      }
   }

   head(url :string) {
      return fetch(url, {
         method: "HEAD",
         cache: "no-cache",
      });
   }
}